import { createSlice } from "@reduxjs/toolkit";
import { Blogs } from "../../Api/Api"; // Import API function

const BlogsSlice = createSlice({
    name: "blogs",
    initialState: {
        blogs: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(Blogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(Blogs.fulfilled, (state, action) => {
                state.blogs = action.payload; // ← was state.products
                state.loading = false;
            })
            .addCase(Blogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default BlogsSlice.reducer;
